import React from "react";
import styles from "./EmptyInbox.module.css";
import PropTypes from "prop-types";

export const EmptyInbox = ({ onLeaveMessageClick }) => {
  return (
    <div className={styles.componentWrapper}>
      <p>You have not received any messages yet.</p>
      <button
        type="button"
        className={styles.messageButton}
        onClick={onLeaveMessageClick}
      >
        Leave a Message
      </button>
    </div>
  );
};

EmptyInbox.propTypes = {
  onLeaveMessageClick: PropTypes.func,
};

export default EmptyInbox;
